/**
 * 调拨出库权限相关字段，来自
 * https://liaofeng.feishu.cn/sheets/shtcnZwEnu3NxrS22N9Onqwtuzb?sheet=a1f812
 */

/**
 * 调拨入库
 */
export const 调拨入库 = 'wms_transfer_work_flow_inbound';
